module.exports = __webpack_public_path__ + "static/media/mmsys_106.7af0653f.ico";